import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Login.module.scss";
import { BrLoading } from "@govbr-ds/react-components";
import { useAuth } from "../../hooks/useAuth/useAuth";

const ROTA_LOGIN_BACK = "/pgrm/api/auth/login";

function Login() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth?.isAuthenticated) {
      navigate("/");
    }
  }, [auth.isAuthenticated, auth.user, navigate]);

  useEffect(() => {
     window.location.href = (ROTA_LOGIN_BACK);
  }, []);

  let content;

  content = (
    <div className={styles.container}>
      <BrLoading large label="Finalizando seu login" />
    </div>
  );

  return <>{content}</>;
}

export default Login;
